import { Provider } from "react-redux";
import "./App.css";
import store from "./redux/store";
import { ThemeProvider } from "@emotion/react";
import theme from "./theme/theme";
import MainRouter from "./navigators/MainRouter";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <MainRouter />
      </Provider>
    </ThemeProvider>
  );
}

export default App;
